import JsxParser from 'react-jsx-parser';
export default class ExtendedJsxParser extends JsxParser {
    shouldComponentUpdate(nextProps) {
        return nextProps.jsx !== this.props.jsx;
    }
}
//# sourceMappingURL=ExtendedJsxParser.js.map